import axios, { AxiosResponse } from 'axios'
import { AtendimentosGestaoCSVResponse, PageResponseAtendimentoGestao } from './_models'

const API_URL = process.env.REACT_APP_API_URL

const ATENDIMENTO_URL = `${API_URL}/atendimentos`

/**
 * Relatório para gestáo de atendimentos
 * @param query string
 * @returns PageResponseAtendimentoGestao
 */
export const getRelatorioGestaoAtendimentos = (
  query: string
): Promise<PageResponseAtendimentoGestao> => {
  return axios
    .get(`${ATENDIMENTO_URL}/gestao?${query}`)
    .then((resp: AxiosResponse<PageResponseAtendimentoGestao>) => resp.data)
}

/**
 * Relátorio para gestáo de atendimentos em CSV
 * @param query string
 * @returns AtendimentosGestaoCSVResponse
 */
export const getRelatorioGestaoAtendimentosCSV = (
  query: string
): Promise<AtendimentosGestaoCSVResponse> => {
  return axios
    .get(`${ATENDIMENTO_URL}/gestao/csv?${query}`)
    .then((resp: AxiosResponse<AtendimentosGestaoCSVResponse>) => resp.data)
}
